import { CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { IContactFormMeta } from '@Shared/containers/form/address/contact/ContactFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
type Props = {
  meta: IContactFormMeta,
  register: UseFormRegister<any>,
  errors: FieldErrors<any>,
};

export default function ContactFormUI({ meta, register, errors }: Props) {
  return (
    <>
      <CC.SimpleGrid columns={{ base:1 }} gridRowGap={4} columnGap={10} px={4} my={2}>
        {/* {displayCustomInputs<IContactFormMeta>(
          meta,
          register,
          errors,
          isLoading, [], [
            'contact1FirstName',
            'contact1LastName'
          ]
        )} */}
        <CustomFormControl isInvalid={!!errors[meta.firstName.name]} label={meta.firstName.label}>
          <CustomTextInput
            meta={meta.firstName}
            register={register(meta.firstName.name)}
            hasError={errors[meta.firstName.name]}
          />
        </CustomFormControl>

        <CustomFormControl isInvalid={!!errors[meta.lastName.name]} label={meta.lastName.label}>
          <CustomTextInput
            meta={meta.lastName}
            register={register(meta.lastName.name)}
            hasError={errors[meta.lastName.name]}
          />
        </CustomFormControl>

        <CustomFormControl isInvalid={!!errors[meta.position.name]} label={meta.position.label}>
          <CustomTextInput
            meta={meta.position}
            register={register(meta.position.name)}
            hasError={errors[meta.position.name]}
          />
        </CustomFormControl>

        <CustomFormControl isInvalid={!!errors[meta.position.name]} label={meta.phone.label}>
          <CustomTextInput
            meta={meta.phone}
            register={register(meta.phone.name)}
            hasError={errors[meta.phone.name]}
          />
        </CustomFormControl>

        <CustomFormControl isInvalid={!!errors[meta.email.name]} label={meta.email.label}>
          <CustomTextInput
            meta={meta.email}
            register={register(meta.email.name)}
            hasError={errors[meta.email.name]}
          />
        </CustomFormControl>
      </CC.SimpleGrid>
    </>
  );
}
